import React from 'react';

import * as S from './styles';

export const Slide7: React.FC = () => {
  return (
    <S.Container>
      <S.PhotoWrapper>
        <S.Photo />
      </S.PhotoWrapper>
      <S.Content>
        <S.Text>
          Beleza: Daniel Hernandez. Styling: Marcell Maia. Vestido, Roksanda
          para CJ Mares. Luvas, Frou Frou Vintage.
        </S.Text>
      </S.Content>
    </S.Container>
  );
};
